import React, { useState } from "react";
import styles from "./style.module.scss";
import ButtonIcon from "../../../../../components/ButtonIcon/ButtonIcon";
import HeadingWithLine from "../../../../../components/HeadingWithLine/HeadingWithLine";
import useCommonStore from "../../../../../stores/common";
import { formatCurrency, formatNumberWithSpaces } from "../../../../../../components/helper/helper";

function CrossIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M12.854 12.1463C12.9005 12.1927 12.9373 12.2479 12.9625 12.3086C12.9876 12.3693 13.0006 12.4343 13.0006 12.5C13.0006 12.5657 12.9876 12.6308 12.9625 12.6915C12.9373 12.7522 12.9005 12.8073 12.854 12.8538C12.8076 12.9002 12.7524 12.9371 12.6917 12.9622C12.631 12.9874 12.566 13.0003 12.5003 13.0003C12.4346 13.0003 12.3695 12.9874 12.3088 12.9622C12.2481 12.9371 12.193 12.9002 12.1465 12.8538L8.00028 8.70691L3.85403 12.8538C3.76021 12.9476 3.63296 13.0003 3.50028 13.0003C3.3676 13.0003 3.24035 12.9476 3.14653 12.8538C3.05271 12.76 3 12.6327 3 12.5C3 12.3674 3.05271 12.2401 3.14653 12.1463L7.2934 8.00003L3.14653 3.85378C3.05271 3.75996 3 3.63272 3 3.50003C3 3.36735 3.05271 3.2401 3.14653 3.14628C3.24035 3.05246 3.3676 2.99976 3.50028 2.99976C3.63296 2.99976 3.76021 3.05246 3.85403 3.14628L8.00028 7.29316L12.1465 3.14628C12.2403 3.05246 12.3676 2.99976 12.5003 2.99976C12.633 2.99976 12.7602 3.05246 12.854 3.14628C12.9478 3.2401 13.0006 3.36735 13.0006 3.50003C13.0006 3.63272 12.9478 3.75996 12.854 3.85378L8.70715 8.00003L12.854 12.1463Z"
        fill="#E03B24"
      />
    </svg>
  );
}

function CheckMark() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M14.3538 4.85378L6.35375 12.8538C6.30732 12.9003 6.25217 12.9372 6.19147 12.9623C6.13077 12.9875 6.06571 13.0004 6 13.0004C5.9343 13.0004 5.86923 12.9875 5.80853 12.9623C5.74783 12.9372 5.69269 12.9003 5.64625 12.8538L2.14625 9.35378C2.05243 9.25996 1.99973 9.13272 1.99973 9.00003C1.99973 8.86735 2.05243 8.7401 2.14625 8.64628C2.24007 8.55246 2.36732 8.49976 2.5 8.49976C2.63269 8.49976 2.75993 8.55246 2.85375 8.64628L6 11.7932L13.6463 4.14628C13.7401 4.05246 13.8673 3.99976 14 3.99976C14.1327 3.99976 14.2599 4.05246 14.3538 4.14628C14.4476 4.2401 14.5003 4.36735 14.5003 4.50003C14.5003 4.63272 14.4476 4.75996 14.3538 4.85378Z"
        fill="#37B450"
      />
    </svg>
  );
}

const renderYesNo = (value) => {
  if (value !== "" && value !== undefined && value !== null) {
    return value === "yes" ? (
      <><CheckMark /> Yes</>
    ) : (
      <><CrossIcon /> No</>
    );
  } else {
    return "-";
  }
}

const getPricingDataById = (id, appData) => {
  let pricing = appData.prices.find((price) => price.id === id);
  return pricing ? pricing.pivot : { dollars: 0, percent: 0 };
};

function PinDebit({ appData }) {
  return (
    <>
      <div>
        <HeadingWithLine text="PIN DEBIT" />
        <ul>
          <li>
            <div>
              <p>Pin Debit</p>
              <p>{renderYesNo(appData.debit_pin)}</p>
            </div>
          </li>
          <li>
            <div>
              <p></p>
              <p></p>
            </div>
          </li>
          <li>
            <div>
              <p>Pin Debit rate</p>
              <p>{getPricingDataById(5, appData)?.percent}%</p>
            </div>
          </li>
          <li>
            <div>
              <p>Pin Debit Txn</p>
              <p>$ {getPricingDataById(5, appData)?.dollars ? formatCurrency(getPricingDataById(5, appData)?.dollars) : 0}</p>
            </div>
          </li>
          <li>
            <div>
              <p>Signature Debit Rate</p>
              <p>{getPricingDataById(6, appData)?.percent}%</p>
            </div>
          </li>

          <li>
            <div>
              <p>Signature Debit Txn</p>
              <p>$ {getPricingDataById(6, appData)?.dollars ? formatCurrency(getPricingDataById(6, appData)?.dollars) : 0}</p>
            </div>
          </li>
        </ul>
      </div>
    </>
  );
}

function GeneralFees({ appData }) {
  return (
    <>
      <div>
        <HeadingWithLine text="General fees" />
        <ul>
          <li>
            <div>
              <p>Service (Monthly)</p>
              <p>$ {getPricingDataById(17, appData)?.dollars ? formatCurrency(getPricingDataById(17, appData)?.dollars) : 0}</p>
            </div>
          </li>
          <li>
            <div>
              <p>Authorization (Per Item)</p>
              <p>$ {getPricingDataById(11, appData)?.dollars ? formatCurrency(getPricingDataById(11, appData)?.dollars) : 0}</p>
            </div>
          </li>
          <li>
            <div>
              <p>Batch Header (Per Batch)</p>
              <p>$ {getPricingDataById(14, appData)?.dollars ? formatCurrency(getPricingDataById(14, appData)?.dollars) : 0}</p>
            </div>
          </li>
          <li>
            <div>
              <p>Voice Authorization (Per Item)</p>
              <p>$ {getPricingDataById(12, appData)?.dollars ? formatCurrency(getPricingDataById(12, appData)?.dollars) : 0}</p>
            </div>
          </li>
          <li>
            <div>
              <p>Chargeback (Per Item)</p>
              <p>$ {getPricingDataById(20, appData)?.dollars ? formatCurrency(getPricingDataById(20, appData)?.dollars) : 0}</p>
            </div>
          </li>
          <li>
            <div>
              <p>Retrieval (Per Item)</p>
              <p>$ {getPricingDataById(21, appData)?.dollars ? formatCurrency(getPricingDataById(21, appData)?.dollars) : 0}</p>
            </div>
          </li>
          <li>
            <div>
              <p>NSF/ACH Reject (Per Item)</p>
              <p>$ {getPricingDataById(22, appData)?.dollars ? formatCurrency(getPricingDataById(22, appData)?.dollars) : 0}</p>
            </div>
          </li>
          <li>
            <div>
              <p>Monthly Minimum (minimum discount)</p>
              <p>$ {getPricingDataById(18, appData)?.dollars ? formatCurrency(getPricingDataById(18, appData)?.dollars) : 0}</p>
            </div>
          </li>
          <li>
            <div>
              <p>Annual Fee</p>
              <p>$ {getPricingDataById(25, appData)?.dollars ? formatCurrency(getPricingDataById(25, appData)?.dollars) : 0}</p>
            </div>
          </li>
          <li>
            <div>
              <p>Early closure (ETF)</p>
              <p>$ {getPricingDataById(27, appData)?.dollars ? formatCurrency(getPricingDataById(27, appData)?.dollars) : 0}</p>
            </div>
          </li>
          <li>
            <div>
              <p>AVS Fee</p>
              <p>$ {getPricingDataById(13, appData)?.dollars ? formatCurrency(getPricingDataById(13, appData)?.dollars) : 0}</p>
            </div>
          </li>
        </ul>
      </div>

      <div>
        <HeadingWithLine text="EBT Fees" />
        <ul>
          <li>
            <div>
              <p>Does Merchant Accept EBT</p>
              <p>{appData.ebt_fees}</p>
            </div>
          </li>
          <li>
            <div>
              <p></p>
              <p></p>
            </div>
          </li>
          {appData.ebt_fees === "yes" && (
            <>
              <li>
                <div>
                  <p>EBT Transactions (Per Item)</p>
                  <p>$ {getPricingDataById(29, appData).dollars ? formatCurrency(getPricingDataById(29, appData).dollars) : 0}</p>
                </div>
              </li>
              <li>
                <div>
                  <p>EBT Transaction (Monthly)</p>
                  <p>$ {getPricingDataById(30, appData).dollars ? formatCurrency(getPricingDataById(30, appData).dollars) : 0}</p>
                </div>
              </li>
              <li>
                <div>
                  <p>EBT Reg Number</p>
                  <p>{getPricingDataById(31, appData).dollars ? formatNumberWithSpaces(getPricingDataById(31, appData).dollars) : 0}</p>
                </div>
              </li>
            </>
          )}
        </ul>
      </div>
    </>
  );
}

function TieredPricing({ appData }) {
  return (
    <>
      <div>
        <HeadingWithLine text="Processing Fees" />
        <ul>
          <li>
            <div>
              <p>Qual Rate</p>
              <p>{getPricingDataById(1, appData).percent}%</p>
            </div>
          </li>
          <li>
            <div>
              <p>Qual Txn Fee</p>
              <p>$ {getPricingDataById(1, appData).dollars ? formatCurrency(getPricingDataById(1, appData).dollars) : 0}</p>
            </div>
          </li>
          <li>
            <div>
              <p>Mid Qual Rate</p>
              <p>{getPricingDataById(3, appData).percent}%</p>
            </div>
          </li>
          <li>
            <div>
              <p>Mod Qual Txn Fee</p>
              <p>$ {getPricingDataById(3, appData).dollars ? formatCurrency(getPricingDataById(3, appData).dollars) : 0}</p>
            </div>
          </li>
          <li>
            <div>
              <p>Non Qual Rate</p>
              <p>{getPricingDataById(4, appData).percent}%</p>
            </div>
          </li>
          <li>
            <div>
              <p> Non Qual Txn Fee</p>
              <p>$ {getPricingDataById(4, appData).dollars ? formatCurrency(getPricingDataById(4, appData).dollars) : 0}</p>
            </div>
          </li>
        </ul>
      </div>

      <PinDebit appData={appData} />

      <GeneralFees appData={appData} />

      <div>
        <HeadingWithLine text="American Express" />
        <ul>
          <li>
            <div>
              <p>Does Merchant want to accept American Express?</p>
              <p>{appData?.apexoptout == "yes" ? "No" : "Yes"}</p>
            </div>
          </li>
          <li>
            <div>
              <p></p>
              <p></p>
            </div>
          </li>
          <li>
            <div>
              <p>{"Tier 1 (<$150)"}</p>
              <p>$ {getPricingDataById(32, appData).percent ? formatCurrency(getPricingDataById(32, appData).percent) : 0}</p>
            </div>
          </li>
          <li>
            <div>
              <p>{"Tier 1 (<$150)"}</p>
              <p>$ {getPricingDataById(32, appData).dollars  ? formatCurrency(getPricingDataById(32, appData).dollars) : 0}</p>
            </div>
          </li>
          <li>
            <div>
              <p>{"Tier 2 ($150 - $3,000)"}</p>
              <p>$ {getPricingDataById(33, appData).percent ? formatCurrency(getPricingDataById(33, appData).percent) : 0}</p>
            </div>
          </li>
          <li>
            <div>
              <p>{"Tier 2 ($150 - $3,000)"}</p>
              <p>$ {getPricingDataById(33, appData).dollars ? formatCurrency(getPricingDataById(33, appData).dollars) : 0}</p>
            </div>
          </li>
          <li>
            <div>
              <p>{"Tier 3 (>$3,000)"}</p>
              <p>$ {getPricingDataById(34, appData).percent ? formatCurrency(getPricingDataById(34, appData).percent) : 0}</p>
            </div>
          </li>
          <li>
            <div>
              <p>{"Tier 3 (>$3,000)"}</p>
              <p>$ {getPricingDataById(34, appData).dollars ? formatCurrency(getPricingDataById(34, appData).dollars) : 0}</p>
            </div>
          </li>
        </ul>
      </div>
    </>
  );
}

function ICPlus({ appData }) {
  return (
    <>
      <div>
        <HeadingWithLine text="Processing Fees" />
        <ul>
          <li>
            <div>
              <p>Passthrough (per item)</p>
              <p>{getPricingDataById(2, appData).percent}%</p>
            </div>
          </li>
          <li>
            <div>
              <p>Passthrough (per item) Txn</p>
              <p>$ {getPricingDataById(2, appData).dollars ? formatCurrency(getPricingDataById(2, appData).dollars) : 0}</p>
            </div>
          </li>
        </ul>
      </div>

      <PinDebit appData={appData} />

      <GeneralFees appData={appData} />

      <div>
        <HeadingWithLine text="American Express" />
        <ul>
          <li>
            <div>
              <p>Does Merchant want to accept American Express?</p>
              <p>{appData?.apexoptout == "yes" ? "No" : "Yes"}</p>
            </div>
          </li>
          <li>
            <div>
              <p></p>
              <p></p>
            </div>
          </li>
          <li>
            <div>
              <p>{"Passthrough (Per Item) Rate"}</p>
              <p>{getPricingDataById(35, appData).percent} %</p>
            </div>
          </li>
          <li>
            <div>
              <p>{"Passthrough (Per Item) Txn"}</p>
              <p>$ {getPricingDataById(35, appData).dollars ? formatCurrency(getPricingDataById(35, appData).dollars) : 0}</p>
            </div>
          </li>
        </ul>
      </div>
    </>
  );
}

function Surcharge({ appData }) {
  return (
    <>
      <div>
        <HeadingWithLine text="Processing Fees" />
        <ul>
          <li>
            <div>
              <p>Passthrough (per item)</p>
              <p>{getPricingDataById(35, appData).percent}%</p>
            </div>
          </li>
        </ul>
      </div>

      <GeneralFees appData={appData} />
    </>
  );
}

function FlatRate({ appData }) {
  return (
    <>
      <div>
        <HeadingWithLine text="Processing Fees" />
        <ul>
          <li>
            <div>
              <p>Passthrough (per item)</p>
              <p>{getPricingDataById(2, appData).percent}%</p>
            </div>
          </li>
          <li>
            <div>
              <p>Passthrough (per item) Txn</p>
              <p>$ {getPricingDataById(2, appData).dollars ? formatCurrency(getPricingDataById(2, appData).dollars) : 0}</p>
            </div>
          </li>
        </ul>
      </div>

      <PinDebit appData={appData} />

      <GeneralFees appData={appData} />

      <div>
        <HeadingWithLine text="American Express" />
        <ul>
          <li>
            <div>
              <p>Does Merchant want to accept American Express?</p>
              <p>{appData?.apexoptout == "yes" ? "No" : "Yes"}</p>
            </div>
          </li>
          <li>
            <div>
              <p></p>
              <p></p>
            </div>
          </li>
          <li>
            <div>
              <p>{"Passthrough (Per Item) Rate"}</p>
              <p>{getPricingDataById(35, appData).percent} %</p>
            </div>
          </li>
          <li>
            <div>
              <p>{"Passthrough (Per Item) Txn"}</p>
              <p>$ {getPricingDataById(35, appData).dollars ? formatCurrency(getPricingDataById(35, appData).dollars) : 0}</p>
            </div>
          </li>
        </ul>
      </div>
    </>
  );
}

function PartnerPricing({ appData }) {
  const expandAppDetails = useCommonStore((state) => state.expandDetails);
  const [expended, setExpended] = useState(false);
  const toggleExpend = () => {
    setExpended(!expended);
  };

  const renderPricing = (appData) => {
    if (appData.qualifiedtype == "tiered")
      return <TieredPricing appData={appData} />;
    if (appData.qualifiedtype == "icppt") return <ICPlus appData={appData} />;
    if (appData.qualifiedtype == "sccd") return <Surcharge appData={appData} />;
    if (appData.qualifiedtype == "frate") return <FlatRate appData={appData} />;
  };

  const getPricingName = (qualifiedtype) => {
    if (qualifiedtype === "tiered") return "Tiered";
    if (qualifiedtype === "sccd") return "Surcharge / Cash Discount";
    if (qualifiedtype === "frate") return "Flat Rate";
    if (qualifiedtype === "icppt") return "IC Plus / Pass Through";
  };

  return (
    <div
      className={`${styles.pricing} ${expandAppDetails ? styles.expanded : ""}`}
    >
      <div className={styles.head}>
        <ButtonIcon onClick={toggleExpend}>
          <svg
            className={expended ? styles.expended : ""}
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
          >
            <path
              d="M17.0306 12.5307L9.53062 20.0307C9.46093 20.1004 9.37821 20.1556 9.28716 20.1933C9.19612 20.2311 9.09854 20.2505 8.99999 20.2505C8.90144 20.2505 8.80386 20.2311 8.71282 20.1933C8.62177 20.1556 8.53905 20.1004 8.46936 20.0307C8.39968 19.961 8.34441 19.8783 8.30669 19.7872C8.26898 19.6962 8.24957 19.5986 8.24957 19.5001C8.24957 19.4015 8.26898 19.3039 8.30669 19.2129C8.34441 19.1218 8.39968 19.0391 8.46936 18.9694L15.4397 12.0001L8.46936 5.03068C8.32863 4.88995 8.24957 4.69907 8.24957 4.50005C8.24957 4.30103 8.32863 4.11016 8.46936 3.96943C8.61009 3.8287 8.80097 3.74963 8.99999 3.74963C9.19901 3.74963 9.38988 3.8287 9.53062 3.96943L17.0306 11.4694C17.1003 11.5391 17.1557 11.6218 17.1934 11.7128C17.2312 11.8039 17.2506 11.9015 17.2506 12.0001C17.2506 12.0986 17.2312 12.1962 17.1934 12.2873C17.1557 12.3783 17.1003 12.461 17.0306 12.5307Z"
              fill="#3A383F"
            />
          </svg>
        </ButtonIcon>
        <h5>Pricing</h5>
      </div>

      <div
        className={`${styles.body} ${expended ? styles.body_expended : ""} ${expandAppDetails ? styles.app_details_expanded : ""}`}
      >
        {expended && (
          <>
            <ul>
              <li>
                <div>
                  <p>Pricing model</p>
                  <p>{getPricingName(appData.qualifiedtype)}</p>
                </div>
              </li>
            </ul>
            {renderPricing(appData)}
          </>
        )}
      </div>
    </div>
  );
}

export default PartnerPricing;
